import script from "./resourcesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./resourcesPage.vue?vue&type=script&setup=true&lang=js"

import "./resourcesPage.vue?vue&type=style&index=0&id=890b8310&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-890b8310"]])

export default __exports__